import { useSavings } from "../../hooks/useSavings";
import Card from "../../components/ui/Card";
import StatCard from "../../components/ui/StatCard";
import Badge from "../../components/ui/Badge";

const fmt = (n: number) =>
new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", currencyDisplay: "symbol", maximumFractionDigits: 0 }).format(n);
const fmtDate = (d: string) =>
  d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

const typeIcon  = (t: string) => t === "savings" ? "💰" : t === "withdrawal" ? "📤" : "🔄";
const typeColor = (t: string) => t === "savings" ? "text-emerald-600" : t === "withdrawal" ? "text-red-500" : "text-blue-600";

export default function ActivityPage() {
  const { data } = useSavings() as any;
  const txns: any[] = (data?.contributions ?? []).slice().sort(
    (a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
  const withdrawtxns: any[] = (data?.withdrawals ?? []).slice().sort(
    (a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );

  const totalContributed = txns.filter(t => t.type === "savings" || t.type === "targeted" || t.type === "investment").reduce((s, t) => s + Number(t.amount), 0);
  const totalWithdrawn   = txns.filter(t => t.type === "withdrawal").reduce((s, t) => s + Number(t.amount), 0);
  const pendingWithdraw   = withdrawtxns.reduce((s, t) => s + Number(t.amount), 0);
  const totalRepaid      = txns.filter(t => t.type === "loan-repayment").reduce((s, t) => s + Number(t.amount), 0);

  const pendingValue = `Pending withdrawal request: ${fmt(pendingWithdraw)}`;

  return (
    <div>
      <div className="grid grid-cols-3 gap-3 mb-5">
        <StatCard label="Total in-flow (including charges)" value={fmt(totalContributed)} color="text-emerald-600" icon="💰"/>
        <StatCard label="Total repaid"       value={fmt(totalRepaid)}      color="text-blue-600"   icon="🔄"/>
        <StatCard label="Total withdrawn"    value={fmt(totalWithdrawn)} sub={pendingValue}   color="text-red-500"    icon="📤"/>
      </div>

      <Card>
        <p className="text-sm font-medium text-slate-700 mb-4">Transaction timeline</p>
        {txns.length === 0 ? (
          <p className="text-sm text-slate-400 text-center py-8">No transactions yet</p>
        ) : (
          <div className="relative">
            <div className="absolute left-[18px] top-0 bottom-0 w-px bg-slate-100"/>
            {txns.map((t: any) => (
              <div key={t.id} className="flex gap-4 pb-5 relative">
                <div className="w-9 h-9 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center text-lg flex-shrink-0 z-10">
                  {typeIcon(t.type)}
                </div>
                <div className="flex-1 pt-1.5">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-sm font-medium text-slate-800 capitalize">{t.type.replace("-", " ")}</p>
                      <p className="text-xs text-slate-400 mt-0.5">{fmtDate(t.created_at)}</p>
                    </div>
                    <div className="text-right">
                      <p className={`text-sm font-medium ${typeColor(t.type)}`}>
                        {t.type === "withdrawal" ? "-" : "+"}{fmt(t.amount)}
                      </p>
                      <Badge label={t.status} color={t.status === "completed" ? "emerald" : t.status === "failed" ? "red" : "amber"}/>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
